import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-266ea850"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-item-container" }
const _hoisted_2 = { class: "form-item-header" }
const _hoisted_3 = { class: "question" }
const _hoisted_4 = { class: "form-item-body" }
const _hoisted_5 = { class: "submissions-container text-h5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_TextInputResponses = _resolveComponent("TextInputResponses")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        class: "gorate-bg-inverted cursor-default",
        icon: _ctx.getFormItemIconIndex,
        height: "30",
        variant: "text",
        width: "30"
      }, null, 8, ["icon"]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formItem.question_lang1), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('i18n.submissions')) + ": " + _toDisplayString(_ctx.getTotalResponses(_ctx.formItemIndex - 1)), 1),
      _createElementVNode("div", {
        class: "view-responses-container cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewSubmissionsModalIsActive = true))
      }, _toDisplayString(_ctx.$t('i18n.viewSubmissions')), 1)
    ]),
    (_ctx.formItem)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: _ctx.viewSubmissionsModalIsActive,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.viewSubmissionsModalIsActive) = $event)),
          "max-width": "60%"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TextInputResponses, {
              formName: _ctx.getFormName,
              formItemID: _ctx.getFormItemID,
              questionLang1: _ctx.getFormItemQuestionLang1,
              onCloseModal: _ctx.closeTextInputSubmissions
            }, null, 8, ["formName", "formItemID", "questionLang1", "onCloseModal"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}